import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../../components/base/Dialog/Dialog';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import { Button, Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import RepresentativeDTO from '../../../../dto/RepresentativeDTO';
import { getProfileData } from '../../reducer';

export function RepresentativeEditFormModal(props) {
  const {
    onClose = () => {}, onSend = () => {},
  } = props;
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();

  const {
    representative,
  } = useSelector(getProfileData);

  const {
    control, getValues,
  } = useForm({
    defaultValues: {
      current: representative?.name_for_applicant,
    },
  });

  return (
    <Dialog
      className="uspd-representative-form"
      onClose={onClose}
      open
    >
      <DialogTitle header="Переименовать приглашение" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="uspd-representative-form-content">
        <Row className="row-cols-1 mt-3">
          <FieldDTOWithCol
            component={TextInputWithLabel}
            dtoObject={{
              name: 'current',
              labelKey: 'Текущее название',
            }}
            disabled
            control={control}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
        <Row className="row-cols-1 mt-3">
          <FieldDTOWithCol
            component={TextInputWithLabel}
            dtoObject={attributes.name_for_applicant}
            control={control}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button variant="secondary" onClick={onClose}>Отменить</Button>
          <Button onClick={() => onSend({ id: representative?.id, name_for_applicant: getValues('name_for_applicant') })}>Переименоваь</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
